function toggleWishlist() {
  let wishlist = Cookies.get("wishlist-items");
  console.log("wishlist togglerclicked");
  if (jQuery(this).hasClass("text-red-500")) {
    let filteredWishlistItems = wishlist.split(",").filter((item) => {
      return (
        item !== jQuery(this).attr("data-product-id") && item !== ""
      );
    });
    Cookies.set("wishlist-items", filteredWishlistItems);
    jQuery(this).toggleClass(
      "far fas text-red-500 text-enewton-gray-400"
    );
    return;
  }
  if (typeof wishlist == "undefined") {
    Cookies.set(
      "wishlist-items",
      jQuery(this).attr("data-product-url")
    );
    jQuery(this).toggleClass(
      "far fas text-red-500 text-enewton-gray-400"
    );
    return;
  }
  wishlist = wishlist.split(",");
  if (wishlist[0] == "") wishlist.shift();
  wishlist.push(jQuery(this).attr("data-product-url"));
  Cookies.set("wishlist-items", wishlist);
  jQuery(this).toggleClass(
    "far fas text-red-500 text-enewton-gray-400"
  );
  return wishlist;
}

function updateWishlist() {
  // update wishlist togglers on page
  let wishlistItems = Cookies.get("wishlist-items");
  if (typeof wishlistItems !== "undefined") {
    wishlistItems = wishlistItems.split(",");
    let wishlistTogglers = jQuery("[data-wishlist-toggle]");
    for (let i = 0; i < wishlistTogglers.length; i++) {
      for (let j = 0; j < wishlistItems.length; j++) {
        if (
          wishlistTogglers[i].attributes["data-product-url"].value ==
          wishlistItems[j]
        ) {
          console.log("wishlist items loaded", wishlistItems);
          jQuery(
            `[data-wishlist-toggle][data-product-url="${wishlistItems[j]}"]`
          ).toggleClass("far fas text-red-500 text-enewton-gray-400");
        }
      }
    }
  }
}


const init = () => {
  jQuery("[data-wishlist-toggle]").on("click", toggleWishlist);
  updateWishlist()
}

export default init
